var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-container",
    [
      _c(
        "sui-menu",
        { attrs: { pointing: "", secondary: "" } },
        _vm._l(_vm.items, function (item) {
          return _c("sui-menu-item", {
            key: item,
            tag: "a",
            attrs: { active: _vm.isActive(item), content: item },
            on: {
              click: function ($event) {
                return _vm.select(item)
              },
            },
          })
        }),
        1
      ),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }